import {ActionReducerMap} from '@ngrx/store';

import {AppState} from './app.state';

import {authReducer as auth} from './../auth/store/auth.reducer';

import {layoutReducer as layout} from './../layout/store/layout.reducer';

export const reducers: ActionReducerMap<AppState> = {auth, layout};
